if (!customElements.get("subscription-module")) {
    customElements.define(
        "subscription-module",
        class SubscriptionModule extends HTMLElement {
            constructor() {
                super();
                this.mainPricesContainer = document.querySelector(".price__wrapper");
                this.purchaseTypeLabels = this.querySelectorAll(".custom-sub-module--purchase-type__label");
                this.oneTimePurchaseContainer = this.querySelector(".custom-sub-module--one-time-purchase__variants-wrapper");
                this.subscriptionPurchaseContainer = this.querySelector(".custom-sub-module--suscription-purchase__content");
                this.variantsInputsOffers = document.querySelectorAll(".variant-input-offer");
                this.variants = this.querySelectorAll(".custom-sub-module--one-time-purchase__variant-label");
                this.deliveryFrequencies = this.querySelectorAll(".custom-sub-module--subscription-purchase__delivery");
                this.deliveryFrequenciesBis = this.querySelectorAll(".custom-sub-module--subscription-purchase__delivery-bis");
                this.subVariantSelector = this.querySelector("#custom-sub-module--subscription-purchase__select");
                this.selectPrices = this.querySelectorAll(".custom-sub-module--subscription-purchase__prices");
                this.variantEconomy = this.querySelectorAll(".custom-sub-module--subscription-purchase__economy");
                this.variantEconomyInline = this.querySelectorAll(".custom-sub-module--subscription-purchase__economy--inline");
                this.variantSavings = this.querySelectorAll(".custom-sub-module--subscription-purchase__reassurances--economy");
                this.subVariantOptions = Array.from(this.subVariantSelector.querySelectorAll("option")).reverse();

                this.connectedCallback = this.connectedCallback.bind(this);
                this.synchronizeVariantsPickers = this.synchronizeVariantsPickers.bind(this);
                this.togglePurchaseType = this.togglePurchaseType.bind(this);
                this.defaultSelectedVariant = this.querySelector(".custom-sub-module--one-time-purchase__variant-label--selected");
                this.forms = document.querySelectorAll("[data-type='add-to-cart-form']");
            }

            connectedCallback() {
                this.variants.forEach((variant) => {
                    variant.addEventListener("click", this.synchronizeVariantsPickers);
                });
                this.subVariantSelector.addEventListener("change", (e) => {
                    this.handleSellingPlanInput(e);
                });
                this.purchaseTypeLabels.forEach((label) => {
                    label.addEventListener("click", this.togglePurchaseType);
                });

                // Gestion des clics sur les liens dans les labels
                this.handleLinkClicks();

                // Initialiser la couleur des badges
                this.initializeBadgeColor();

                // Initialiser l'état des anchors (one-time sélectionné par défaut)
                this.toggleAnchors('one-time');

                this.defaultSelectedVariant.click();
            }

            initializeBadgeColor() {
                const container = this.querySelector('.custom-sub-module--container');
                if (container && container.dataset.badgeColor) {
                    container.style.setProperty('--badge-color', container.dataset.badgeColor);
                }
            }

            handleLinkClicks() {
                // Sélectionner tous les liens dans les labels anchor
                const labelAnchors = this.querySelectorAll('.custom-sub-module--one-time__label-anchor modal-opener');

                labelAnchors.forEach(link => {
                    link.addEventListener('click', (e) => {
                        // Empêcher la propagation de l'événement vers le label
                        e.stopPropagation();
                        // Le comportement par défaut du lien (navigation) est conservé
                    });
                });
            }

            handleSellingPlanInput(e) {
                this.forms.forEach((form) => {
                    if (form.querySelector('input[name="properties[_selling_plan]"]')) {
                        form.querySelector('input[name="properties[_selling_plan]"]').remove();
                    }
                });
                this.createSellinPlanInput(e.target);

                // Synchroniser les fréquences de livraison et les prix
                this.synchronizeDeliveryFrequency();
                this.synchronizeSelectPrice();
            }

            createSellinPlanInput(element) {
                this.forms.forEach((form) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = "selling_plan";
                    input.value = element.options[element.selectedIndex].dataset.planId;
                    form.appendChild(input);
                });
            }

            updateVariantInForms(variantSelected, purchaseType = 'one-time') {
                if (!variantSelected || !variantSelected.dataset.variantId) return;

                this.forms.forEach((form) => {
                    const variantInput = form.querySelector('input[name="id"]');
                    if (variantInput) {
                        variantInput.value = variantSelected.dataset.variantId;
                    }

                    // Mettre à jour l'input quantity avec la valeur du dataset UNIQUEMENT pour l'achat unique
                    if (purchaseType === 'one-time' && variantSelected.dataset.quantity) {
                        let quantityInput = form.querySelector('input[name="quantity"]');
                        if (quantityInput) {
                            quantityInput.value = variantSelected.dataset.quantity;
                        } else {
                            // Créer l'input quantity s'il n'existe pas
                            quantityInput = document.createElement("input");
                            quantityInput.type = "hidden";
                            quantityInput.name = "quantity";
                            quantityInput.value = variantSelected.dataset.quantity;
                            form.appendChild(quantityInput);
                        }
                    } else if (purchaseType === 'subscription') {
                        // Pour les abonnements, supprimer ou réinitialiser la quantité à 1
                        let quantityInput = form.querySelector('input[name="quantity"]');
                        if (quantityInput) {
                            quantityInput.value = 1;
                        }
                    }
                });
            }

            togglePurchaseType(e) {
                const target = e.currentTarget;
                const purchaseType = target.dataset.type;
                const selectedValue = this.subVariantSelector.options[this.subVariantSelector.selectedIndex].dataset.index;
                let variantSelected;

                // Si on revient sur "one-time", forcer la sélection du premier variant
                if (purchaseType === "one-time") {
                    // Sélectionner le premier variant disponible
                    const firstVariant = this.variants[0];
                    if (firstVariant) {
                        variantSelected = firstVariant;
                        // Appliquer le style de sélection au premier variant
                        this.variants.forEach((variant) => {
                            this.applyStyleToVariant(variant, variant === firstVariant);
                        });
                        // Synchroniser avec les inputs radio
                        this.variantsInputsOffers.forEach((variantOffer) => {
                            if (variantOffer.dataset.value == firstVariant.dataset.value) {
                                this.handleVariantOfferClick(variantOffer, true);
                            }
                        });
                    }
                } else {
                    // Pour subscription, garder le comportement existant
                    this.variants.forEach((variant) => {
                        if (variant.dataset.index && parseInt(variant.dataset.index) == parseInt(selectedValue)) {
                            variantSelected = variant;
                        }
                    });
                }

                this.purchaseTypeLabels.forEach((label) => {
                    label.classList.toggle("custom-sub-module-label--selected", label == target);
                });
                if (purchaseType == "subscription") {
                    this.oneTimePurchaseContainer.classList.remove("custom-sub-module--purchase-type__content-visible");
                    this.oneTimePurchaseContainer.classList.add("custom-sub-module--purchase-type__content-hidden");
                    this.subscriptionPurchaseContainer.classList.remove("custom-sub-module--purchase-type__content-hidden");
                    this.subscriptionPurchaseContainer.classList.add("custom-sub-module--purchase-type__content-visible");
                    this.createSellinPlanInput(this.subVariantSelector);
                    this.updateMainSubscriptionsPrices(variantSelected);
                    this.updateVariantInForms(variantSelected, purchaseType);
                } else {
                    this.updateMainPrices(variantSelected);
                    this.updateVariantInForms(variantSelected, purchaseType);
                    this.forms.forEach((form) => {
                        const inputs = form.querySelectorAll('input[name="selling_plan"]');
                        inputs.forEach((input) => {
                            input.remove();
                        });
                    });

                    this.subscriptionPurchaseContainer.classList.add("custom-sub-module--purchase-type__content-hidden");
                    this.subscriptionPurchaseContainer.classList.remove("custom-sub-module--purchase-type__content-visible");
                    this.oneTimePurchaseContainer.classList.remove("custom-sub-module--purchase-type__content-hidden");
                    this.oneTimePurchaseContainer.classList.add("custom-sub-module--purchase-type__content-visible");
                }
                this.toggleAnchors(purchaseType);
            }

            synchronizeVariantsPickers(e) {
                let selectedValue;
                let variantSelected;
                selectedValue = e.target.dataset.value || this.subVariantSelector.value;

                this.variants.forEach((variant) => {
                    if (variant.dataset.value == selectedValue) {
                        variantSelected = variant;
                        this.applyStyleToVariant(variant, variant.dataset.value == selectedValue);
                    } else {
                        this.applyStyleToVariant(variant, false);
                    }
                });

                this.variantsInputsOffers.forEach((variantOffer) => {
                    if (variantOffer.dataset.value == variantSelected.dataset.value) {
                        this.handleVariantOfferClick(variantOffer, variantOffer.dataset.value == variantSelected.dataset.value);
                    }
                });

                // Suppression de la synchronisation du subVariantSelector pour les achats uniques
                // this.subVariantOptions.forEach((option) => {
                //     option.selected = option.dataset.index == e.target.dataset.index;
                // });
                this.updateMainPrices(variantSelected);
                // this.synchronizeSelectPrice();
                this.updateVariantInForms(variantSelected, 'one-time');
            }

            synchronizeVariantsPickersSelect(e) {
                const selectedValue = e.target.options[e.target.selectedIndex].dataset.index;
                let variantSelected;

                this.variants.forEach((variant) => {
                    if (variant.dataset.index && parseInt(variant.dataset.index) == parseInt(selectedValue)) {
                        variantSelected = variant;
                        this.applyStyleToVariant(variant, variant.dataset.value == variantSelected.dataset.value);
                    } else {
                        this.applyStyleToVariant(variant, false);
                    }
                });

                this.variantsInputsOffers.forEach((variantOffer) => {
                    if (variantOffer.dataset.value == variantSelected.dataset.value) {
                        this.handleVariantOfferClick(variantOffer, variantOffer.dataset.value == variantSelected.dataset.value);
                    }
                });

                this.subVariantOptions.forEach((option) => {
                    option.selected = option.dataset.index == variantSelected.dataset.index;
                });

                setTimeout(() => {
                    this.synchronizeDeliveryFrequency();
                    this.synchronizeSelectPrice();
                    this.updateMainSubscriptionsPrices(variantSelected);
                    this.updateVariantInForms(variantSelected, 'subscription');
                });
            }

            applyStyleToVariant(variant, isSelected) {
                variant.classList.toggle("custom-sub-module--one-time-purchase__variant-label--selected", isSelected);
            }

            handleVariantOfferClick(variantOffer, shouldClick) {
                if (shouldClick) {
                    variantOffer.querySelector("label").click();
                }
            }


            toggleAnchors(purchaseType) {
                const oneTimeAnchor = this.querySelector(".custom-sub-module--one-time__label-anchor");
                const subscriptionAnchor = this.querySelector(".custom-sub-module--subscription-purchase__anchor");

                if (purchaseType === 'one-time') {
                    // One-time sélectionné : afficher anchor dans one-time, masquer dans subscription
                    oneTimeAnchor.classList.remove("hide");
                    subscriptionAnchor.classList.add("hide");
                } else if (purchaseType === 'subscription') {
                    // Subscription sélectionné : masquer anchor dans one-time, afficher dans subscription
                    oneTimeAnchor.classList.add("hide");
                    subscriptionAnchor.classList.remove("hide");
                }
            }

            synchronizeDeliveryFrequency() {
                // Récupérer l'index du selling plan sélectionné
                const selectedOption = this.subVariantSelector.options[this.subVariantSelector.selectedIndex];
                const isDefaultOption = selectedOption && selectedOption.disabled;

                // Si l'option par défaut est sélectionnée ou aucune option valide, afficher l'élément par défaut
                if (isDefaultOption || !selectedOption) {
                    this.deliveryFrequencies.forEach((delivery) => {
                        if (delivery.id === 'custom-sub-module--subscription-purchase__delivery--default') {
                            delivery.style.display = "block";
                        } else {
                            delivery.style.display = "none";
                        }
                    });
                } else {
                    // Une vraie option est sélectionnée
                    const selectedPlanIndex = parseInt(selectedOption.dataset.index) - 1;

                    this.deliveryFrequencies.forEach((delivery) => {
                        // Masquer l'élément par défaut
                        if (delivery.id === 'custom-sub-module--subscription-purchase__delivery--default') {
                            delivery.style.display = "none";
                        } else {
                            // Extraire l'index de l'ID (ex: "...-delivery--0" -> 0)
                            const idMatch = delivery.id.match(/--(\d+)$/);
                            if (idMatch) {
                                const deliveryIndex = parseInt(idMatch[1]);
                                delivery.style.display = deliveryIndex === selectedPlanIndex ? "block" : "none";
                            }
                        }
                    });
                }
            }

            synchronizeSelectPrice() {
                // Récupérer l'index du selling plan sélectionné
                const selectedOption = this.subVariantSelector.options[this.subVariantSelector.selectedIndex];
                const selectedPlanIndex = selectedOption ? parseInt(selectedOption.dataset.index) : 1;

                this.selectPrices.forEach((prices, index) => {
                    prices.style.display = index + 1 === selectedPlanIndex ? "block" : "none";
                });
                this.variantEconomy.forEach((economy, index) => {
                    economy.style.display = index + 1 === selectedPlanIndex ? "block" : "none";
                });
                this.variantEconomyInline.forEach((economyInline, index) => {
                    economyInline.style.display = index + 1 === selectedPlanIndex ? "block" : "none";
                });

                this.variantSavings.forEach((savings, index) => {
                    savings.style.display = index + 1 === selectedPlanIndex ? "block" : "none";
                });
            }

            updateMainPrices(selectedOption) {
                const priceContainer = this.mainPricesContainer;
                const price = selectedOption.dataset.price;

                priceContainer.innerHTML = price;
                this.updateDailyCost(selectedOption, "ONE-TIME");
            }

            updateMainSubscriptionsPrices(selectedOption) {
                const priceContainer = this.mainPricesContainer;

                const price = selectedOption.dataset.price;
                const reductedPrice = selectedOption.dataset.reductedPrice;

                priceContainer.innerHTML = reductedPrice;
                this.updateDailyCost(selectedOption, "SUBSCRIPTION");
            }

            updateDailyCost(selectedOption, purchaseType) {
                const dailyCostContainer = this.mainPricesContainer.querySelector(".daily-cost-container");
                if (!dailyCostContainer) return;
                const dailyCostAmountValue = dailyCostContainer.querySelector(".daily-cost-amount-value");
                const posology = dailyCostContainer.dataset.posology;
                const unitByProduct = dailyCostContainer.dataset.unitByProduct;

                let dailyCost = (selectedOption.dataset.singleCost / unitByProduct) * posology;
                if (purchaseType === "SUBSCRIPTION") {
                    dailyCost = (selectedOption.dataset.singleCostReducted / unitByProduct) * posology;
                }
                dailyCostAmountValue.innerHTML = formatPrice(dailyCost);
            }
        }
    );
}